import * as React from 'react';
import { Path } from 'react-native-svg';

function Hearts() {
  return (
    <>
      <Path
        d="M31.53 67.94a26.25 26.25 0 014.37-13 43.3 43.3 0 0110.25-9.38 54.23 54.23 0 016-3.46c1-.52 2.08-1 3.14-1.45s2.19-.87 3.31-1.19A35.27 35.27 0 0165.46 38a40.62 40.62 0 017-.22 45.66 45.66 0 016.9.86 48.19 48.19 0 016.64 1.8 49.23 49.23 0 016.41 2.71A36.53 36.53 0 0198.32 47a35.62 35.62 0 019.11 10.61 25.69 25.69 0 012.09 13.61A27.54 27.54 0 00104.77 59a31.64 31.64 0 00-8.31-9.72 37.7 37.7 0 00-11.41-6 46.16 46.16 0 00-6.3-1.7 41.6 41.6 0 00-6.47-.8 36.93 36.93 0 00-6.48.2 32.14 32.14 0 00-6.31 1.3c-1 .29-2 .71-3 1.08s-2 .88-3 1.38A50.54 50.54 0 0047.82 48a40.73 40.73 0 00-9.56 8.71 28.74 28.74 0 00-6.73 11.23z"
        fill="#ec6da3"
      />
      <Path
        d="M46.5 46.35a12.89 12.89 0 01-3.38-3.45 4.32 4.32 0 010-4.59 9.93 9.93 0 012.68-2 3.14 3.14 0 001.69-2.7c-.14-1.28-1.55-2.05-2.83-2.12s-2.55.37-3.84.42-2.76-.41-3.24-1.6.46-2.81 1.68-3.55 2.66-1 3.89-1.74a6.61 6.61 0 002.85-7.5c-.88-2.76-2.69 5.2-.34 3.91M90.22 44.32a12.71 12.71 0 003.38-3.44 4.32 4.32 0 000-4.6 9.65 9.65 0 00-2.67-2 3.14 3.14 0 01-1.7-2.7c.14-1.28 1.55-2.06 2.84-2.12s2.54.36 3.83.42 2.76-.41 3.24-1.6-.46-2.81-1.67-3.55-2.67-1-3.89-1.75a6.61 6.61 0 01-2.86-7.5c.89-2.75 2.7 5.2.34 3.91"
        fill="none"
        stroke="#ec6da3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.44}
      />
      <Path
        d="M41.24 22.8a19.31 19.31 0 01-8-13.86A4.24 4.24 0 0134 5.79c1-1.17 2.82-1.1 4.24-.56 3.28 1.26 5 4.26 5.68 7.52 1.41-3.72 3.22-7 7-8.87a3.37 3.37 0 011.34-.41 2.85 2.85 0 012.25 1.19 6.12 6.12 0 01.83 5.24 17.44 17.44 0 01-2.41 4.92 83.67 83.67 0 01-5.29 7.77c-2.74 3.41-3.24 2.51-6.4.21zM88.19 21.58A19.26 19.26 0 0179 8.53a4.29 4.29 0 01.37-3.2c.88-1.25 2.71-1.36 4.17-1 3.38.94 5.36 3.77 6.36 7C90.93 7.49 92.41 4 96 1.84a3.44 3.44 0 011.3-.53 2.83 2.83 0 012.34 1A6.07 6.07 0 01101 7.42a17.65 17.65 0 01-2 5.12 82.47 82.47 0 01-4.55 8.24c-2.32 3.59-2.9 2.79-6.26.8z"
        fill="#e84971"
        stroke="#ec6da3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.44}
      />
    </>
  );
}

export default Hearts;
